import { render, staticRenderFns } from "./start-application-modal.vue?vue&type=template&id=260f78a2"
import script from "./start-application-modal.vue?vue&type=script&lang=ts"
export * from "./start-application-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260f78a2')) {
      api.createRecord('260f78a2', component.options)
    } else {
      api.reload('260f78a2', component.options)
    }
    module.hot.accept("./start-application-modal.vue?vue&type=template&id=260f78a2", function () {
      api.rerender('260f78a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/subdomain-interstitial/start-application-modal.vue"
export default component.exports